import { Col, Container, Row } from 'react-bootstrap';
import './discreteReferenceChecks.css';
import _ from 'lodash';
import pdfIcon from '../../../../assets/images/Ic_Pdf.png';
import DownloadCV from '../../../../assets/images/ic_download.png';
import ClientUserService from '../../../../services/client-services/clientUserService';

const DiscreteReferenceChecks = ({ reference1, reference2 }) => {

  const isReferenceEmpty = (ref) => {
    if (!ref) return true;
    const name = _.get(ref, 'name');
    const designation = _.get(ref, 'designation');
    const organisation = _.get(ref, 'organisation');
    const relation = _.get(ref, 'relation');
    const report = _.get(ref, 'report[0]');
    return !(name || designation || organisation || relation || report);
  };

  const downloadFile = (resumePath, fileName) => {
    ClientUserService.downloadFile(encodeURI(resumePath))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };

  const renderReference = (reference) => {
    const name = _.get(reference, 'name', null);
    const designation = _.get(reference, 'designation', null);
    const organisation = _.get(reference, 'organisation', null);
    const relation = _.get(reference, 'relation', null);
    const report = _.get(reference, 'report[0]', null);
    const fileSize = _.get(report, 'fileSize', null);
    const fileSizeUnit = _.get(report, 'fileSizeUnit', 'MB');
    const formattedFileSize = fileSize ? `${fileSize} ${fileSizeUnit}` : 'Unknown Size';
    const filePath = _.get(report, 'path', '');
    const fileName = _.get(report, 'originalName', 'Unknown File');

    return (
      <>
        {relation && (
          <Row>
            <Col>
              <h3 className="discreteCheckTitle1">{relation}</h3>
            </Col>
          </Row>
        )}
        {name && (
          <Row className="mt-2">
            <Col className="discreteCheckSubtext1">Name</Col>
            <Col className="discreteCheckSubtext2">{name}</Col>
          </Row>
        )}
        {designation && (
          <Row className="mt-2">
            <Col className="discreteCheckSubtext1">Designation</Col>
            <Col className="discreteCheckSubtext2">{designation}</Col>
          </Row>
        )}
        {organisation && (
          <Row className="mt-2">
            <Col className="discreteCheckSubtext1">Organization</Col>
            <Col className="discreteCheckSubtext2">{organisation}</Col>
          </Row>
        )}
        {report && (
          <Row className="mt-2 p-2">
            <Col className="reference-file">
              <img src={pdfIcon} alt="PDF Icon" className="pdf-icon" />
              <div className="file-info">
                <span className="file-name">{_.get(report, 'originalName', 'Unknown File')}</span>
                {/* <span className="file-size">{formattedFileSize}</span> Displaying the formatted file size */}
              </div>
              <div className="download-icon">
                <a onClick={() => downloadFile(filePath, fileName)}>
                  <img src={DownloadCV} alt="Download icon" />
                </a>
              </div>
            </Col>
          </Row>
        )}
      </>
    );
  };

  return (
    <Container className="pt-2 pb-3">
      <Row>
        <Col>
          <h3 className="reference-heading">Discreet Reference Checks</h3>
          <hr />
          <div className="reference-container">
            <div className={`reference-item ${isReferenceEmpty(reference1) ? 'no-data' : ''}`}>
              {!isReferenceEmpty(reference1) && renderReference(reference1)}
            </div>
            <div className={`reference-item ${isReferenceEmpty(reference2) ? 'no-data' : ''}`}>
              {!isReferenceEmpty(reference2) && renderReference(reference2)}
            </div>
          </div>

        </Col>
      </Row>
    </Container>
  );
};

export default DiscreteReferenceChecks;